// Chart geometry that doesn't need a DOM, so it can be tested. Ported from the phone's
// GlucoseChart.kt placeMarkers().

export interface MarkerInput {
  /** Where the marker's time is on the x axis. */
  trueX: number;
  radius: number;
}

/**
 * Entries logged minutes apart land on the same pixel at day scale, so markers are nudged
 * sideways until they don't overlap, then pulled back inside the right edge. `markers` must be
 * sorted by `trueX`; returns where to draw each one.
 */
export function placeMarkers(markers: MarkerInput[], left: number, right: number, gap: number): number[] {
  const xs: number[] = new Array(markers.length);
  for (let i = 0; i < markers.length; i++) {
    const m = markers[i]!;
    const earliest = i === 0 ? left : xs[i - 1]! + markers[i - 1]!.radius + m.radius + gap;
    xs[i] = Math.max(m.trueX, earliest);
  }
  for (let i = markers.length - 1; i >= 0; i--) {
    const m = markers[i]!;
    const latest = i === markers.length - 1 ? right : xs[i + 1]! - markers[i + 1]!.radius - m.radius - gap;
    xs[i] = Math.min(xs[i]!, latest);
  }
  return xs;
}

/** The index of the item whose position is closest to `x`, within `maxDistance`; -1 if none. Ties go to the first. */
export function nearestIndex(positions: number[], x: number, maxDistance: number): number {
  let best = -1;
  let bestDistance = Infinity;
  for (let i = 0; i < positions.length; i++) {
    const d = Math.abs(positions[i]! - x);
    if (d < bestDistance) {
      best = i;
      bestDistance = d;
    }
  }
  return bestDistance <= maxDistance ? best : -1;
}

/** The index of the last sorted value <= `t`, or -1. */
export function lastAtOrBefore(sorted: number[], t: number): number {
  let lo = 0;
  let hi = sorted.length - 1;
  let found = -1;
  while (lo <= hi) {
    const mid = (lo + hi) >> 1;
    if (sorted[mid]! <= t) {
      found = mid;
      lo = mid + 1;
    } else {
      hi = mid - 1;
    }
  }
  return found;
}
